__turbopack_context__.v({
  "ctaBadges": "RedesignBemutato-module__9dBWIG__ctaBadges",
  "ctaSection": "RedesignBemutato-module__9dBWIG__ctaSection",
  "ctaSub": "RedesignBemutato-module__9dBWIG__ctaSub",
  "ctaTitle": "RedesignBemutato-module__9dBWIG__ctaTitle",
  "eyebrow": "RedesignBemutato-module__9dBWIG__eyebrow",
  "eyebrowDot": "RedesignBemutato-module__9dBWIG__eyebrowDot",
  "featureBlock": "RedesignBemutato-module__9dBWIG__featureBlock",
  "featureDesc": "RedesignBemutato-module__9dBWIG__featureDesc",
  "featureHighlight": "RedesignBemutato-module__9dBWIG__featureHighlight",
  "featureNumber": "RedesignBemutato-module__9dBWIG__featureNumber",
  "featureText": "RedesignBemutato-module__9dBWIG__featureText",
  "featureTitle": "RedesignBemutato-module__9dBWIG__featureTitle",
  "featureVisual": "RedesignBemutato-module__9dBWIG__featureVisual",
  "featureVisualDark": "RedesignBemutato-module__9dBWIG__featureVisualDark",
  "features": "RedesignBemutato-module__9dBWIG__features",
  "footer": "RedesignBemutato-module__9dBWIG__footer",
  "footerCopy": "RedesignBemutato-module__9dBWIG__footerCopy",
  "footerLinks": "RedesignBemutato-module__9dBWIG__footerLinks",
  "footerLogo": "RedesignBemutato-module__9dBWIG__footerLogo",
  "illus": "RedesignBemutato-module__9dBWIG__illus",
  "pageHeader": "RedesignBemutato-module__9dBWIG__pageHeader",
  "pageSub": "RedesignBemutato-module__9dBWIG__pageSub",
  "pageTitle": "RedesignBemutato-module__9dBWIG__pageTitle",
  "reverse": "RedesignBemutato-module__9dBWIG__reverse",
  "site": "RedesignBemutato-module__9dBWIG__site",
  "statItem": "RedesignBemutato-module__9dBWIG__statItem",
  "statLabel": "RedesignBemutato-module__9dBWIG__statLabel",
  "statNum": "RedesignBemutato-module__9dBWIG__statNum",
  "statsBar": "RedesignBemutato-module__9dBWIG__statsBar",
  "storeBadge": "RedesignBemutato-module__9dBWIG__storeBadge",
});
